import React, { Component } from 'react';
import { combined } from '../shared/status';
import Link from '../../view/Link';
import './tabset.scss';

class Player extends Component {
  render() {
    const {
      item: { content },
      view,
      childPlayer,
      path,
    } = this.props;
    return (
      <div className="tabs_container">
        <div className="tabs">
          {content.items.map((item, index) => {
            const props = {
              className: index === view.current ? 'active' : '',
              view: { [path]: index },
              key: index,
            };
            return <Link {...props}>{item.title}</Link>;
          })}
        </div>
        <div className="tabs_body">
          {childPlayer(view.current, content.items[view.current])}
        </div>
      </div>
    );
  }
}

Player.displayName = 'TabSet';

export default { Player, status: combined };
